// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2E8tx","image":"Header_image__1mbUW"};